import { createSlice } from '@reduxjs/toolkit';
import { fetchRequestFromSearch, reviewRequest, updateFilesRequest } from '../SearchRequest/requestSearchSlice';
import { fetchSimulateEquivalencyRequest, saveStudent, saveRequest, fetchEquivalencyRuleActivity, searchPreviousEquivalencyRequest, fetchCompatibilityTargetSyllabuses, fetchSourceSyllabusActivities, fetchTargetSyllabusActivities, fetchHubspotContact, fetchRequestById } from '../Request/requestSlice';
import { t } from 'i18next';

interface LoadingInitialStateInterface {
  value: boolean
  count: number
  text: string | null
}

const initialState:LoadingInitialStateInterface = {
  value: false,
  count: 0,
  text: null
};

export const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    startLoad: (state) => {
      state.value = true;
    },
    finishLoad: (state) => {
      state.value = false;
    }
  },
  extraReducers: (builder) => {
    const thunks = [
      fetchSimulateEquivalencyRequest,
      fetchRequestFromSearch,
      fetchRequestById,
      saveStudent,
      fetchEquivalencyRuleActivity,
      updateFilesRequest,
      searchPreviousEquivalencyRequest,
      fetchCompatibilityTargetSyllabuses,
      fetchSourceSyllabusActivities,
      fetchTargetSyllabusActivities,
      fetchHubspotContact,
      reviewRequest
    ];

    builder.addCase(saveRequest.pending, (state) => {
      state.count++;
      state.value = true;
      state.text = t('requestLoading');
    });
    builder.addCase(saveRequest.fulfilled, (state) => {
      state.count--;
      if (state.count === 0) {
        state.value = false;
      }
    });
    builder.addCase(saveRequest.rejected, (state) => {
      state.count--;
      if (state.count === 0) {
        state.value = false;
      }
    });

    for (const thunk of thunks) {
      builder.addCase(thunk.pending, (state) => {
        state.count++;
        state.value = true;
        state.text = '';
      });
      builder.addCase(thunk.fulfilled, (state) => {
        state.count--;
        if (state.count === 0) {
          state.value = false;
        }
      });
      builder.addCase(thunk.rejected, (state) => {
        state.count--;
        if (state.count === 0) {
          state.value = false;
           }
      });
    }
  }
});
export const { startLoad, finishLoad } = loadingSlice.actions;

export default loadingSlice.reducer;
